<template>
  <b-col>
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="12">
            <label>{{$t("views.surveys.form.groupsQuestionsTitle")}}:</label>
            <b-form-input dense v-model="questionGroup.title" name="surveyTitle" :placeholder="$t('views.surveys.form.groupsQuestionsTitle')"/>
          </b-col>
          <b-col cols="12" class="mt-0 pt-0">
            <b-form-group>
              <label>{{$t("views.surveys.form.groupsQuestionsDescription")}}:</label>
              <textarea rows="1" class="form-control" id="description" v-model="questionGroup.description" :placeholder="$t('views.surveys.form.groupsQuestionsDescription')"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="4">
        <draggable
          v-model="questionGroup.surveyQuestions"
          :animation="300"
          handle=".cursor-move"
          tag="ul"
          class="nav nav-pills flex-column"
          role="tablist"
        >
          <li
            v-for="(surveyQuestion, key) in questionGroup.surveyQuestions"
            :key="key"
            class="d-flex align-items-center"
          >
            <a
              href="#"
              class="nav-link flex-grow-1 d-flex align-items-center survey-tab-question-text"
              :class="{ active: activeQuestionTab === key }"
              @click.prevent="activeQuestionTab = key"
              v-b-tooltip.hover
              :title="surveyQuestion.questionDescription.length > 18 ? surveyQuestion.questionDescription : null"
            >
              <i class="fa fa-th cursor-move mr-2 text-muted"></i>
              <span>{{ $t("views.surveys.form.question") }} - </span>
              <span v-if="surveyQuestion.questionDescription.length === 0">{{ key + 1 }}</span>
              <span v-else> {{ truncateTitle(surveyQuestion.questionDescription) }} </span>
              <span class="ml-auto"></span>
            </a>
            <b-button
              variant="link"
              class="p-0 ml-2"
              @click="duplicateItemCollection(surveyQuestion, 'question')"
              v-b-tooltip.hover
              :title="$t('buttons.duplicate')"
            >
              <i class="fa fa-copy text-primary"></i>
            </b-button>
            <b-button
              variant="link"
              class="p-0 ml-2"
              @click="removeItemCollection(key, 'question')"
              v-b-tooltip.hover
              :title="$t('buttons.delete')"
            >
              <i class="fa fa-trash text-danger"></i>
            </b-button>
          </li>
        </draggable>

        <b-button
          size="sm"
          variant="success"
          block
          class="mt-2"
          @click="addNewItemCollection('questionGroup')"
        >
          <i class="fa fa-plus mr-1"></i> {{ $t('buttons.addQuestion') }}
        </b-button>
      </b-col>

      <b-col cols="8">
        <div class="tab-content">
          <div
            v-for="(surveyQuestion, key) in questionGroup.surveyQuestions"
            :key="'pane-' + key"
            class="tab-pane fade"
            :class="{ show: activeQuestionTab === key, active: activeQuestionTab === key }"
          >
            <surveys-questions :survey-question="surveyQuestion" />
          </div>
        </div>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import draggable from 'vuedraggable'
import SurveysQuestions from '@/components/Dashboard/Views/AgreementsBundle/surveys/components/surveysQuestions.vue'
export default {
  name: 'surveyGroupsQuestions',
  components: { SurveysQuestions, draggable },
  props: {
    questionGroup: {
      type: Object,
      required: true
    }
  },
  watch: {
    'questionGroup.surveyQuestions.length' (len) {
      if (this.activeQuestionTab >= len) this.activeQuestionTab = Math.max(0, len - 1)
    }
  },
  data () {
    return {
      refreshKey: 0,
      activeQuestionTab: 0
    }
  },
  methods: {
    truncateTitle (title) {
      if (title.length > 30) {
        title = title.substring(0, 30) + '...'
      }
      return title
    },
    addNewItemCollection (type) {
      let objectGD
      if (type === 'questionGroup') {
        if (this.questionGroup.surveyQuestions === null || this.questionGroup.surveyQuestions === undefined) {
          this.questionGroup.surveyQuestions = []
        }
        objectGD = {
          questionDescription: '',
          questionType: 1,
          surveyQuestionAnswers: [],
          required: 0,
          allowedExtensions: ''
        }
        this.questionGroup.surveyQuestions.push(objectGD)
      }
    },
    removeItemCollection (itemIndex, type) {
      if (type === 'question') {
        this.questionGroup.surveyQuestions.splice(itemIndex, 1)
      }
    },
    duplicateItemCollection (item, type) {
      if (type === 'question') {
        let newItem = JSON.parse(JSON.stringify(item))
        this.questionGroup.surveyQuestions.push(newItem)
      }
    }
  }
}
</script>
